/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dashboard_Action_Ai_Tailor_DescInputs */

const en_dashboard_action_ai_tailor_desc = /** @type {(inputs: Dashboard_Action_Ai_Tailor_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Match your resume to a specific job with AI-powered optimization.`)
};

const de_dashboard_action_ai_tailor_desc = /** @type {(inputs: Dashboard_Action_Ai_Tailor_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Passe deinen Lebenslauf mit KI-gestützter Optimierung an eine bestimmte Stelle an.`)
};

const fr_dashboard_action_ai_tailor_desc = /** @type {(inputs: Dashboard_Action_Ai_Tailor_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Adapte ton CV à un emploi spécifique grâce à l'optimisation par IA.`)
};

const es_dashboard_action_ai_tailor_desc = /** @type {(inputs: Dashboard_Action_Ai_Tailor_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Adapte su currículum a un empleo específico con optimización por IA.`)
};

const it_dashboard_action_ai_tailor_desc = /** @type {(inputs: Dashboard_Action_Ai_Tailor_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abbina il tuo curriculum vitae a un lavoro specifico con l'ottimizzazione alimentata dall'AI.`)
};

const nl_dashboard_action_ai_tailor_desc = /** @type {(inputs: Dashboard_Action_Ai_Tailor_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pas je cv aan op een specifieke baan met AI-geoptimaliseerde optimalisatie.`)
};

const pl_dashboard_action_ai_tailor_desc = /** @type {(inputs: Dashboard_Action_Ai_Tailor_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dopasuj swoje CV do konkretnej pracy z optymalizacją zasilaną przez AI.`)
};

const fi_dashboard_action_ai_tailor_desc = /** @type {(inputs: Dashboard_Action_Ai_Tailor_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sovita ansiotodistuksesi tiettyyn työpaikkaan AI-optimointilla.`)
};

const da_dashboard_action_ai_tailor_desc = /** @type {(inputs: Dashboard_Action_Ai_Tailor_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Match dit CV til et specifikt job med AI-drevet optimering.`)
};

const sv_dashboard_action_ai_tailor_desc = /** @type {(inputs: Dashboard_Action_Ai_Tailor_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Matcha ditt CV till ett specifikt jobb med AI-optimering.`)
};

/**
* | output |
* | --- |
* | "Match your resume to a specific job with AI-powered optimization." |
*
* @param {Dashboard_Action_Ai_Tailor_DescInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const dashboard_action_ai_tailor_desc = /** @type {((inputs?: Dashboard_Action_Ai_Tailor_DescInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dashboard_Action_Ai_Tailor_DescInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_dashboard_action_ai_tailor_desc(inputs)
	if (locale === "fr") return fr_dashboard_action_ai_tailor_desc(inputs)
	if (locale === "es") return es_dashboard_action_ai_tailor_desc(inputs)
	if (locale === "it") return it_dashboard_action_ai_tailor_desc(inputs)
	if (locale === "nl") return nl_dashboard_action_ai_tailor_desc(inputs)
	if (locale === "pl") return pl_dashboard_action_ai_tailor_desc(inputs)
	if (locale === "fi") return fi_dashboard_action_ai_tailor_desc(inputs)
	if (locale === "da") return da_dashboard_action_ai_tailor_desc(inputs)
	if (locale === "sv") return sv_dashboard_action_ai_tailor_desc(inputs)
	return en_dashboard_action_ai_tailor_desc(inputs)
});